import React, { useState } from "react";
import { Box, Typography, TextField, Button, Alert, Grid } from "@mui/material";
import Layout from "./Layout";
import axios from "axios";
import { Link } from "react-router-dom";

const ForgotCredentials = () => {
  const [formData, setFormData] = useState({
    email: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [submissionError, setSubmissionError] = useState("");
  const [submissionSuccess, setSubmissionSuccess] = useState("");
  const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const errors = {};

    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Enter a valid email address";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionError("");
    setSubmissionSuccess("");

    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      const response = await axios.post(`${baseURL}/licensing/email_license/`, {
        email_id: formData.email,
      });

      if (response.data.status === "Pass") {
        setSubmissionSuccess(
          "Please check your email for your user ID and license key.",
        );
      } else {
        setSubmissionError(response.data.status);
      }
    } catch (error) {
      console.error(error);
      setSubmissionError(
        error.response?.data?.message || "An unexpected error occurred.",
      );
    }
  };

  return (
    <Layout>
      <Typography variant="h5" gutterBottom>
        Forgot Credentials
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        {submissionError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {submissionError}
          </Alert>
        )}

        {submissionSuccess && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {submissionSuccess}
          </Alert>
        )}

        <TextField
          name="email"
          label="Email Address"
          fullWidth
          margin="normal"
          value={formData.email}
          onChange={handleChange}
          error={!!formErrors.email}
          helperText={formErrors.email}
        />

        <Button fullWidth variant="contained" type="submit" sx={{ mt: 2 }}>
          Email User ID and License Key
        </Button>

        <Box mt={2}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Link to="/register">New here? Sign Up</Link>
            </Grid>
            <Grid item xs={12}>
              <Link to="/login">Already have an account? Log In</Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Layout>
  );
};

export default ForgotCredentials;
